import { CatalogItem } from 'types/catalog-filters'
import { CatalogModel, CatalogNavigationModel } from 'types/models/catalog'

export const catalogsInAscOrder = (catalog: CatalogModel, other: CatalogModel) =>
  catalog.order - other.order

export const catalogsNavigationsInAscOrder = (
  catalog: CatalogNavigationModel,
  other: CatalogNavigationModel,
) => catalog.order - other.order

export const catalogModelToCatalogListItem = (catalog: CatalogNavigationModel): CatalogItem => {
  const { id, title, catalogIds, parentId, code, depth, photo, badge } = catalog

  return {
    id,
    title,
    value: id,
    data: {
      id,
      catalogIds,
      parentId,
      code,
      depth,
      photo,
      badge,
    },
  }
}

export const catalogModelsToCatalogListItems = (
  catalogs: Array<CatalogNavigationModel>,
): Array<CatalogItem> => catalogs.map(catalogModelToCatalogListItem)

export const getNewPriceRange = (
  priceFrom: string | null | undefined,
  priceTo: string | null | undefined,
) => {
  if (priceFrom && priceTo && parseFloat(priceFrom) > parseFloat(priceTo)) {
    return { priceFrom: priceTo, priceTo: null }
  }

  return { priceTo, priceFrom }
}
